import MenuContext, { MenuContextProps, MenuTheme } from 'antd/es/menu/MenuContext';
export default MenuContext;
